import React, {useState} from 'react'

import BButton from 'components/Form/Fields/BButton'

const AddNew = ({children, title}) => {
  const [addNew, setAddNew] = useState(false)

  return (
    addNew ? (
      children
    ) : (
      <BButton onClick={_ => setAddNew(true)} bordered>{title}</BButton>
    )
  )
}

export default AddNew
